<template>
  <div>
    <div class="row justify-end ml-0 mr-0 mb-3">
      <v-select
        v-if="approval === true"
        v-model="authStatus"
        :items="authStatusItem"
        label="인증상태 전체선택"
        persistent-hint
        single-line
        outlined
        dense
        class="pa-0"
        style="max-width: 200px"
        hide-details
        @change="changeAuthStatus()"
      ></v-select>
    </div>

    <v-card class="manageCodeList col-12 mb-4 pb-0">
      <div class="row justify-end mt-0 mb-0">
        <div class="row justify-start mt-0 mb-0" style="padding-left: 25px">
          <v-btn
            v-if="approval"
            small
            color="grey darken-4"
            class="white--text"
            @click="batchApproved"
            >승인처리</v-btn
          >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="grey lighten-1"
                dark
                v-on="on"
                small
                class="mr-3 ml-2"
              >
                인증회원정보 참고 사항
                <v-icon class="ml-2">mdi-information-outline</v-icon>
              </v-btn>
            </template>

            <p class="text-start">* 전화번호가 빈 항목으로 들어와요!</p>
            <p class="text-start ma-0">
              현재 제공되는 카페24 회원 정보 조회 api의 경우
            </p>
            <p class="text-start ma-0">
              회원가입시 입력되는 전화번호만 제공하고 있습니다.
            </p>
            <p class="text-start ma-0">
              따라서 쇼핑몰에 따라 회원가입시 휴대전화만으로 가입하거나
            </p>
            <p class="text-start ma-0">
              전화번호가 필수가 아닌 경우 전화번호 정보가 미노출될 수
            </p>
            <p class="text-start">있습니다.</p>
            <p class="text-start ma-0">
              해당 경우에는 '정품인증항목 추가' 기능을 통해 휴대폰 번호를
            </p>
            <p class="text-start ma-0">
              쇼핑몰에서 별도 입력 받는 방법으로 사용하시길 권장합니다.
            </p>
            <p class="text-start ma-0">
              ※ 관련 메뉴 [정품 인증 설정 > 회원 정품인증항목 추가]
            </p>
          </v-tooltip>
        </div>
        <v-btn
          small
          color="green"
          class="white--text ml-3 mr-3"
          @click.prevent="excelDownload"
          >엑셀 다운로드</v-btn
        >
      </div>

      <!-- 
        :server-items-length="productInfosCount"
        :items-per-page="$parent.$refs.searchComponent.searchPayload.limit"
      -->
      <v-data-table
        v-model="selectedProduct"
        :headers="headers"
        :items="productInfo_items"
        :options.sync="options"
        :loading="tableLoading"
        calculate-widths
        :show-select="approval"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
          'items-per-page-text': '목록 노출 수 선택:',
        }"
        item-key="serial_number"
        scrollable
        class="pl-1 pr-1 memberMansgeTable"
        :search="authStatus"
        :server-items-length="productInfosCount"
        :items-per-page="$parent.$refs.searchComponent.searchPayload.limit"
      >
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
        >
          <v-simple-checkbox
            v-if="item.cert_status !== 'approved'"
            :value="isSelected"
            @input="select($event)"
            v-ripple="{ class: 'green--text' }"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.auth_at`]="{ item }">
          <p
            class="mb-0 mt-3 text-center caption"
            style="padding-left: 0px"
            v-html="$options.filters.defaultDate(item.auth_at)"
          ></p>
        </template>

        <template v-slot:[`item.approved_at`]="{ item }">
          <p
            class="mb-0 mt-3 text-center caption"
            v-html="$options.filters.defaultDate(item.approved_at)"
          ></p>
        </template>

        <template v-slot:[`item.cert_status`]="{ item }">
          <p class="mb-0 mt-3 caption" v-if="item.cert_status == 'inactivated'">
            미인증
          </p>
          <p class="mb-0 mt-3 caption" v-if="item.cert_status == 'activated'">
            인증완료
          </p>
          <p class="mb-0 mt-3 caption" v-if="item.cert_status == 'approved'">
            승인완료
          </p>
        </template>

        <template v-slot:[`item.auth_member_info`]="{ item }">
          <div class="text-start mb-3 mt-3">
            <a
              class="primary--text memberInfoHover mb-3 mt-3 caption text-start"
              @click="showMemberInfoPage(item.auth_member_info.id)"
            >
              ID :
              {{ item.auth_member_info.id ? item.auth_member_info.id : "-" }}
              <br />
              이름 :
              {{
                item.auth_member_info.name ? item.auth_member_info.name : "-"
              }}
              <br />
              전화번호 :
              {{ item.auth_member_info.hp ? item.auth_member_info.hp : "-" }}
              <br />
              이메일 :
              {{
                item.auth_member_info.email ? item.auth_member_info.email : "-"
              }}
              <br />
              회원등급명 :
              {{
                item.auth_member_info.level ? item.auth_member_info.level : "-"
              }}
              <br />
            </a>
          </div>
        </template>

        <template v-slot:[`item.auth_item`]="{ item }">
          <div v-if="item.auth_item.length > 0">
            <div v-for="(optionItem, index) in item.auth_item" :key="index">
              <p v-if="!optionItem.type" class="mb-0 mt-0 caption text-start">
                {{ optionItem.subject }} :
                {{ optionItem.value ? optionItem.value : "-" }}
              </p>
              <p v-else class="mb-0 mt-0 caption text-start">
                {{ optionItem.subject }} :
                <a @click="addFileOpen(optionItem)">첨부파일</a>
              </p>
            </div>
          </div>
          <div v-else>
            <p class="mb-0 mt-0 caption text-center">-</p>
          </div>
        </template>

        <template v-slot:[`item.cert_validated_at`]="{ item }">
          <a
            @click="daysClick(item)"
            class="caption"
            v-html="
              $options.filters.warrantyPeriod({
                cert_status: item.cert_status,
                cert_duration_type: item.cert_duration_type,
                cert_duration: item.cert_duration,
                cert_validated_at: item.cert_validated_at,
                cert_expired_at: item.cert_expired_at,
                bought_at: item.bought_at,
              })
            "
          ></a>
        </template>

        <template v-slot:[`item.serial_number`]="{ item }">
          <p class="mb-0 mt-0 caption" @click="authCodeClick(item)">
            <a>{{ item.serial_number }}</a>
          </p>
        </template>

        <template v-slot:[`item.image`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
          <v-row no-gutters>
            <v-col>
              <v-img
                v-if="item.image"
                :src="item.image"
                width="60px"
                height="60px"
              ></v-img>
              <v-img
                v-else
                :src="adminDefaultImg"
                width="60px"
                height="60px"
              ></v-img>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.auth_product_info`]="{ item }">
          <p class="mb-0 mt-3 caption text-start">
            상품명 : {{ item.auth_product_info.product_name }}
          </p>
          <p class="mb-0 mt-0 caption text-start">
            품목명 : {{ item.auth_product_info.variant_name }}
          </p>
          <p class="mb-0 mt-0 caption text-start">
            상품코드 : {{ item.auth_product_info.product_code }}
          </p>
          <p class="mb-3 mt-0 caption text-start">
            품목코드 : {{ item.auth_product_info.variant_code }}
          </p>
        </template>

        <template v-slot:[`item.memo`]="{ item }">
          <v-btn
            v-if="item.memo"
            small
            text
            color="primary"
            @click="memoModalShow(item)"
            ><v-icon small>mdi-message-reply</v-icon> 메모</v-btn
          >
          <v-btn v-else small @click="memoModalShow(item)">메모</v-btn>
        </template>

        <template slot="no-data">
          <div class="noDataProductInfos">내역이 없습니다.</div>
        </template>
      </v-data-table>

      <!--
      Modal
    -->
      <v-row justify="center">
        <v-dialog persistent max-width="310" v-model="removeConfirm">
          <v-card>
            <v-card-title class="headline"></v-card-title>
            <v-card-text>
              <p class="mb-0">선택하신 정품인증코드를 파기하시면</p>
              <p class="mb-0">관련된 이력과 함께 모두 사라지게 됩니다.</p>
              <p class="mb-0">정말로 파기하시겠습니까?</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="black darken-1"
                text
                @click.prevent="removeConfirm = false"
                >취소</v-btn
              >
              <v-btn color="blue darken-1" @click.prevent="sendRemoveCode" text
                >파기</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <AuthCodeClickModal ref="AuthCodeClickModal"></AuthCodeClickModal>
      <QrCodePrintModal ref="QrCodePrintModal"></QrCodePrintModal>
      <AuthWarrantyPeriodChangeModal
        ref="AuthWarrantyPeriodChangeModal"
      ></AuthWarrantyPeriodChangeModal>
      <UnAuthWarrantyPeriodChangeModal
        ref="UnAuthWarrantyPeriodChangeModal"
      ></UnAuthWarrantyPeriodChangeModal>
      <AuthStateChangeModal ref="AuthStateChangeModal"></AuthStateChangeModal>
    </v-card>
    <MemoModal ref="MemoModal"></MemoModal>
  </div>
</template>
<style>
.noDataProductInfos {
  padding: 50px 0;
}
.manageCodeList a:hover {
  text-decoration: underline;
}
.disabledBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.4444444444px;
  font-size: 0.75rem;
  background-color: #f5f5f5;
  color: #bababa;
}

.v-data-table.memberMansgeTable td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 8px;
  padding-right: 8px;
}

.memberMansgeTable.theme--light.v-data-table thead tr:last-child th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  padding-left: 8px;
  padding-right: 8px;
}
/*
style="text-decoration: underline; text-decoration-color : #1976d2;"
*/
.memberMansgeTable .underline :hover {
  cursor: pointer;
  text-decoration: underline;
}

.memberMansgeTable .memberInfo .hover :hover {
  cursor: pointer;
  text-decoration: underline;
}
.memberInfoHover {
  cursor: pointer;
}
.memberInfoHover :hover {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #1976d2;
}
</style>
<script>
//import Vue from "vue";
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";
import AuthCodeClickModal from "@/components/authservice/authcode/modal/AuthCodeClickModal.vue";
import QrCodePrintModal from "@/components/authservice/authcode/modal/QrCodePrintModal.vue";
import AuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/AuthWarrantyPeriodChangeModal.vue";
import UnAuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/UnAuthWarrantyPeriodChangeModal.vue";
import AuthStateChangeModal from "@/components/authservice/authcode/modal/AuthStateChangeModal.vue";
import Excel from "@/libs/excel.js";

import MemoModal from "@/components/authservice/auth_member/modal/MemoModal.vue";

export default {
  data() {
    return {
      AUTH_SERVICE,
      headers: [
        {
          text: "인증일시",
          align: "center",
          sortable: false,
          value: "auth_at",
          width: 60,
          filterable: false,
        },
        {
          text: "승인일시",
          align: "center",
          value: "approved_at",
          sortable: false,
          width: 60,
          filterable: false,
        },
        {
          text: "인증상태",
          align: "center",
          value: "cert_status",
          sortable: false,
          width: 70,
          filterable: true,
        },
        {
          text: "인증회원정보",
          align: "center",
          value: "auth_member_info",
          sortable: false,
          width: 150,
          filterable: false,
        },
        {
          text: "정품 인증 항목",
          align: "center",
          value: "auth_item",
          sortable: false,
          width: 120,
          filterable: false,
        },
        {
          text: "보증기간",
          align: "center",
          value: "cert_validated_at",
          sortable: false,
          width: 120,
          filterable: false,
        },
        {
          text: "정품인증코드",
          align: "center",
          value: "serial_number",
          sortable: false,
          width: 120,
        },
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
          filterable: false,
        },
        {
          text: "인증 상품 정보",
          align: "center",
          value: "auth_product_info",
          sortable: false,
          width: 180,
          filterable: false,
        },
        {
          text: "메모",
          align: "center",
          value: "memo",
          sortable: false,
          width: 80,
          filterable: false,
        },
      ],
      selectedProduct: [],
      removeConfirm: false,
      productInfos: [],
      productInfosCount: 0,
      options: {},
      tableLoading: false,
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          auth_at: "인증일시",
          approved_at: "승인일시",
          cert_duration_info: "인증설정기준",
          cert_duration_type: "보증기간",
          cert_status: "인증상태",
          //image: "이미지",
          serial_number: "인증코드",
          product_name: "상품명",
          variant_name: "품목명",
          product_code: "상품코드",
          variant_code: "품목코드",
          member_id: "회원 아이디",
          member_hp: "회원 전화번호",
          member_email: "회원 이메일",
          member_level: "회원 등급",
        },
      },
      printSettingInfo: "N",
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png"),
      authStatus: "",
      authStatusItem: [
        { text: "인증상태 전체", value: "" },
        { text: "인증완료", value: "activated" },
        { text: "승인완료", value: "approved" },
      ],
      approval: true,
      authItemList: [],
    };
  },
  components: {
    AuthCodeClickModal,
    QrCodePrintModal,
    AuthWarrantyPeriodChangeModal,
    UnAuthWarrantyPeriodChangeModal,
    AuthStateChangeModal,
    MemoModal,
  },
  mixins: [CommonMixin],
  filters: Filters,

  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    //this.eventHub.$on("memberSetList", this.setAuthMemberList);
    await this.getApproval();
    await this.getAuthItems();
  },
  watch: {
    options: {
      handler() {
        this.$parent.$refs.searchComponent.execSearch(false);
      },
      deep: true,
    },
  },
  computed: {
    productInfo_items() {
      return this.productInfos.map((x) => ({
        ...x,
        isSelectable: x.cert_status != "approved",
      }));
    },
  },
  methods: {
    setAuthMemberList: function(data) {
      this.selectedProduct = [];
      this.productInfosCount = data.count;
      this.productInfos = data.serials;
      this.tableLoading = false;
    },
    authCodeClick: function(data) {
      this.$refs.AuthCodeClickModal.authCodeClick(data);
    },
    daysClick: function(data) {
      this.$refs.UnAuthWarrantyPeriodChangeModal.warrantyPeriodClick(data);
    },
    authStateClick: function(data) {
      this.$refs.AuthStateChangeModal.authStateClick(data);
    },
    barCodePrintClick: function() {
      if (this.$store.state.mode !== AUTH_SERVICE.APP_MODE.PLUS) {
        this.alertShow(
          "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요."
        );
        return false;
      }

      if (!this.productInfos) {
        this.alertShow("정품QR코드 인쇄할 데이터가 없습니다.");
        return false;
      }

      if (this.printSettingInfo == "N") {
        this.alertShow(
          "인쇄 설정이 되어 있지 않습니다. [정품 QR 코드 인쇄 설정] 메뉴에서 설정하시면 사용이 가능합니다."
        );
        return false;
      }

      this.$refs.QrCodePrintModal.barCodePrintClick(
        this.$parent.$refs.searchComponent.$data.searchPayload
      );
    },
    /**
     * 엑셀 다운로드 체크
     */
    excelDownload: async function() {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = 0;

      let data = await M.api(M.entry("/get/user/search"), excelPayload);

      if (data.length === 0) {
        this.alertShow("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }
      this.excelData.totalCount = data.count;
      if (this.excelData.totalCount > this.excelData.totalLimit) {
        this.alertShow(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건</br>이내로 검색하여 다운로드 해주세요."
        );
        return false;
      }

      let setExcelDataArray = [];
      for (let i = 0; i < data.serials.length; i++) {
        /*
        if (data.serials[i].auth_item.length == 0) {
          data.serials[i].auth_item.push({
            subject: "텍스트 항목",
            value: "테스트 value"
          });
          data.serials[i].auth_item.push({
            subject: "배열 항목",
            value: ["옵션체크1", "옵션체크2"]
          });
        }
        */

        let excelDatas = {
          approved_at: data.serials[i].approved_at,
          auth_at: data.serials[i].auth_at,
          cert_expired_at: data.serials[i].cert_expired_at,
          cert_status: data.serials[i].cert_status,
          cert_validated_at: data.serials[i].cert_validated_at,
          created_at: data.serials[i].created_at,
          serial_number: data.serials[i].serial_number,
          auth_item: data.serials[i].auth_item,
          product_name: data.serials[i].auth_product_info.product_name,
          variant_name: data.serials[i].auth_product_info.variant_name,
          product_code: data.serials[i].auth_product_info.product_code,
          variant_code: data.serials[i].auth_product_info.variant_code,
          cert_duration_type: data.serials[i].cert_duration_type,
          cert_duration: data.serials[i].cert_duration,
          member_id: data.serials[i].auth_member_info.id,
          member_hp: data.serials[i].auth_member_info.hp,
          member_email: data.serials[i].auth_member_info.email,
          member_level: data.serials[i].auth_member_info.level,
        };

        if (data.serials[i].auth_item.length > 0) {
          for (let j = 0; j < data.serials[i].auth_item.length; j++) {
            if (data.serials[i].auth_item[j].subject) {
              let subject = data.serials[i].auth_item[j].subject;
              let value = data.serials[i].auth_item[j].value;

              let idx = this.authItemList.indexOf(subject);
              if (idx < 0) {
                continue;
              }

              if (Array.isArray(value)) {
                value = value.join("/");
              }
              this.excelData.sheetHeader[subject] = subject;
              excelDatas[subject] = value;
            }
          }
        }

        let warrentDate = "";
        if (data.serials[i].cert_duration_type == AUTH_SERVICE.ACTIVATED) {
          warrentDate = "인증일로부터 ";
        } else if (data.serials[i].cert_duration_type == AUTH_SERVICE.CREATED) {
          warrentDate = "생성일로부터 ";
        } else {
          warrentDate = "구매일로부터 ";
        }

        let days = data.serials[i].cert_duration.replace(/[^0-9]/g, "");
        let date = data.serials[i].cert_duration.replace(/[^a-zA-Z]/g, "");

        switch (date) {
          case "y":
            date = "년";
            break;
          case "m":
            date = "개월";
            break;
          case "d":
            date = "일";
            break;
        }
        warrentDate += days + date;
        excelDatas["cert_duration_info"] = warrentDate;

        setExcelDataArray.push(excelDatas);
      }

      //return;
      this.excelData.sheetData = setExcelDataArray;
      this.checkExcelDataChange();
      this.initExcelDownload();
    },
    /**
     * 엑셀 시작
     */
    initExcelDownload: function() {
      let progressText = "엑셀 다운로드중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      // this.defaultProgressShow();
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.circularProgressSetValue(
        Math.round((this.excelData.offset / this.excelData.totalCount) * 100)
      );
      if (this.excelData.offset > this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;

      let data = await M.api(M.entry("/get/user/search"), excelPayload);
      if (data.length === 0) {
        await this.endExcel();
        return false;
      }
      // this.excelData.sheetData = data.serials;

      let setExcelDataArray = [];
      for (let i = 0; i < data.serials.length; i++) {
        let excelDatas = {
          approved_at: data.serials[i].approved_at,
          auth_at: data.serials[i].auth_at,
          cert_expired_at: data.serials[i].cert_expired_at,
          cert_status: data.serials[i].cert_status,
          cert_validated_at: data.serials[i].cert_validated_at,
          created_at: data.serials[i].created_at,
          serial_number: data.serials[i].serial_number,
          auth_item: data.serials[i].auth_item,
          product_name: data.serials[i].auth_product_info.product_name,
          variant_name: data.serials[i].auth_product_info.variant_name,
          product_code: data.serials[i].auth_product_info.product_code,
          variant_code: data.serials[i].auth_product_info.variant_code,
          cert_duration_type: data.serials[i].cert_duration_type,
          cert_duration: data.serials[i].cert_duration,
          member_id: data.serials[i].auth_member_info.id,
          member_hp: data.serials[i].auth_member_info.hp,
          member_email: data.serials[i].auth_member_info.email,
          member_level: data.serials[i].auth_member_info.level,
        };

        if (data.serials[i].auth_item.length > 0) {
          for (let j = 0; j < data.serials[i].auth_item.length; j++) {
            if (data.serials[i].auth_item[j].subject) {
              let subject = data.serials[i].auth_item[j].subject;
              let value = data.serials[i].auth_item[j].value;

              let idx = this.authItemList.indexOf(subject);
              if (idx < 0) {
                continue;
              }

              if (Array.isArray(value)) {
                value = value.join("/");
              }
              this.excelData.sheetHeader[subject] = subject;
              excelDatas[subject] = value;
            }
          }
        }

        let warrentDate = "";
        if (data.serials[i].cert_duration_type == AUTH_SERVICE.ACTIVATED) {
          warrentDate = "인증일로부터 ";
        } else if (data.serials[i].cert_duration_type == AUTH_SERVICE.CREATED) {
          warrentDate = "생성일로부터 ";
        } else {
          warrentDate = "구매일로부터 ";
        }

        let days = data.serials[i].cert_duration.replace(/[^0-9]/g, "");
        let date = data.serials[i].cert_duration.replace(/[^a-zA-Z]/g, "");

        switch (date) {
          case "y":
            date = "년";
            break;
          case "m":
            date = "개월";
            break;
          case "d":
            date = "일";
            break;
        }
        warrentDate += days + date;
        excelDatas["cert_duration_info"] = warrentDate;

        setExcelDataArray.push(excelDatas);
      }

      this.excelData.sheetData = setExcelDataArray;

      this.checkExcelDataChange();
      this.excelData.Excel.addSheet(this.excelData.sheetData);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        await this.excelData.Excel.addSheet(this.excelData.sheetData);
        await this.getExcelDataAdd();
      } else {
        await this.getExcelDataAdd();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.circularProgressHide();
      }, 1500);
      // this.defaultProgressHide();
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}`
      );
    },
    /**
     * excel데이터 변경
     */
    checkExcelDataChange: function() {
      if (this.excelData.sheetData.length > 0) {
        this.excelData.sheetData.forEach((data) => {
          for (let key in data) {
            if (key === "cert_status") {
              data[key] = this.$options.filters.certStatus(data[key]);
            }
            if (key === "cert_duration_type") {
              data[key] = this.$options.filters
                .warrantyPeriod(data)
                .replace("</br>", "");
            }
          }
        });
      }
    },
    removeCode: async function() {
      if (this.selectedProduct.length === 0) {
        this.alertShow("파기하실 정품 인증 코드를 선택해주세요.");
      } else {
        this.removeConfirm = true;
      }
    },
    sendRemoveCode: async function() {
      let payload = {
        serial_numbers: [],
      };
      payload["serial_numbers"] = this.selectedProduct.map(
        (item) => item.serial_number
      );
      try {
        await M.api(M.entry("/serials/del"), payload);
        this.removeConfirm = false;
        this.eventHub.$emit("execSearch", false);
      } catch (e) {
        this.removeConfirm = false;
        this.alertShow("현재 서버 통신이 불안정합니다. 잠시 후 사용해주세요.");
      }
    },
    checkVersionAlret: function() {
      let msg =
        "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      this.alertShow(msg);
    },
    showMemberInfoPage: function(memberId) {
      let url =
        "https://" +
        this.$store.state.mallId +
        ".cafe24.com/admin/php/shop1/c/member_admin_d_f.php?user_id=" +
        memberId;

      window.open(url, "_blank");
    },
    //일괄 승인 처리
    batchApproved: async function() {
      if (this.selectedProduct.length == 0) {
        alert("선택해주세요.");
        return false;
      }

      if (confirm("선택하신 회원을 승인완료 하시겠습니까?")) {
        for (let i = 0; i < this.selectedProduct.length; i++) {
          let setData = {
            cert_status: "approved",
            member_id: this.selectedProduct[i].auth_member_info.id,
          };

          try {
            await M.api(
              M.entry("/serials/status", this.selectedProduct[i].serial_number),
              setData
            );
          } catch (e) {
            //
          }
        }
        this.$parent.$refs.searchComponent.execSearch(false);
      }
    },
    //정품 인증 관리자 승인 조회
    getApproval: async function() {
      try {
        let data = await M.api(M.entry("/get/config/approval"));

        if (data.status !== "enabled") {
          this.approval = false;
        }
      } catch (e) {
        this.approval = false;
        this.removeConfirm = false;
        this.alertShow("현재 서버 통신이 불안정합니다. 잠시 후 사용해주세요.");
      }
      //미설정시 기능 제한
      if (this.approval === false) {
        let find = this.headers.find(function(item) {
          return item.value === "approved_at";
        });
        let idx = this.headers.indexOf(find);
        if (idx > -1) this.headers.splice(idx, 1);

        this.$parent.$refs.searchComponent.$data.dateTypeItems.splice(1, 1);
      }
    },
    changeAuthStatus: function() {
      //data table
      this.$parent.$refs.searchComponent.searchPayload.cert_status = this.authStatus;
      this.$parent.$refs.searchComponent.execSearch(false);
    },
    addFileOpen: function(v) {
      window.open(v.value, "_blank");
    },
    /**
     * 정품 인증 관리자 승인 설정 조회
     */
    getAuthItems: async function() {
      let data = await M.api(M.entry("/get/config/authItems"), {});
      for (let i = 0; i < data.length; i++) {
        this.authItemList.push(data[i].text);
      }
    },
    memoModalShow: function(item) {
      this.$refs.MemoModal.show(item);
    },
    setMemo: function(serial_number, memo) {
      const index = this.productInfo_items.findIndex((e) => {
        return e.serial_number == serial_number;
      });
      let set_param = this.productInfo_items[index];
      set_param.memo = memo;
      this.productInfos.splice(index, 1, set_param);
    },
  },
};
</script>
